/**
 * Tutorial guidato di Impostazioni > Immagini: misure delle miniature e servizi (Photoroom).
 *
 * Nessun preparativo: la pagina e' un elenco di misure con un bottone per aggiungerne
 * una e, sotto, i servizi. Il tutorial non apre menu, non aggiunge misure e non tocca i servizi.
 */
const SCOPE = '[data-tour-scope="setting-thumbnail"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createThumbnailTourSteps() {
	return [
		{
			body: "Ogni immagine caricata nel gestionale viene salvata anche in versioni piu' piccole, una per ogni misura indicata qui: servono al sito per non scaricare l'originale da due megabyte dove basta una miniatura.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le misure delle miniature',
		},
		{
			body: "L'elenco delle misure attive, in pixel. Riguardano il lato lungo dell'immagine: poche misure ben scelte bastano - una per le liste, una per la scheda prodotto, una per il carrello.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Le misure attive',
		},
		{
			body: "Da qui si apre il riquadro per una misura nuova, con le misure piu' comuni a portata di click. Attenzione a quando la si aggiunge: le immagini gia' caricate non vengono rigenerate, la misura nuova vale da qui in avanti.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere una misura',
		},
		{
			body: "I tre puntini a inizio riga aprono Modifica ed Elimina. Togliere o cambiare una misura usata dal sito vuol dire che le immagini gia' caricate non hanno la misura nuova: conviene farlo solo sapendo dove veniva usata.",
			key: 'row-menu',
			missing: 'skip',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o togliere una misura',
		},
		{
			body: "Qui si collegano i servizi che lavorano sulle immagini. Photoroom scontorna, sistema la luce, aggiunge ombre e ambientazioni: si usa dalla scheda prodotto, con il bottone Migliora immagine sulla foto.",
			key: 'services',
			placement: 'top',
			target: at('services'),
			title: 'Servizi per le immagini',
		},
		{
			body: "Il + apre le impostazioni: la chiave API creata su Photoroom e l'interruttore Sandbox. In sandbox le prove sono gratuite ma le immagini escono con il watermark; spenta, ogni immagine scala un credito. Verifica connessione controlla la chiave e mostra le immagini disponibili.",
			key: 'services-expand',
			missing: 'skip',
			placement: 'right',
			target: at('services-expand'),
			title: 'Chiave e sandbox',
		},
	];
}
